// import { action } from 'mobx';
import { Units as BaseUnits } from '@sagano/share/stores';

export class Units extends BaseUnits {}

export default new Units();
